import React, { Component } from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner, Table, Alert } from "react-bootstrap";
import swal from 'sweetalert';
import C from '../lib/Config';

const SKIP_REASONS = [
    'Chemotherapy done at another hospital',
    'Treatment was not advisible',
    'Chemotherapy taken but not registerd in Aristo',
    'Other'
];

export default class SkippedCyclesPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            showValidation: false,
            validationMsg: '',
            saveLoader: false,
        };
        this.registerDeviation = this.registerDeviation.bind(this);
    }

    // Called by parent (via ref) with the list returned from getChemoScheduleListBeforeDate
    setRows(list) {
        const rows = (Array.isArray(list) ? list : []).map(item => ({
            ...item,
            skipChecked: false,
            skipReason: '',
            comment: '',
        }));
        this.setState({ rows, showValidation: false, validationMsg: '' });
    }

    formatDateDDMonYYYY(date) {
        if (date !== undefined && date !== "" && date !== null) {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var dateObj = new Date(date);
            var day = String(dateObj.getDate()).padStart(2, '0');
            var month = months[dateObj.getMonth()];
            var year = dateObj.getFullYear();
            return `${day}-${month}-${year}`;
        }
        return "";
    }

    handleCheckChange(idx, checked) {
        this.setState(prevState => {
            const rows = prevState.rows.map((r, i) => {
                if (i !== idx) return r;
                // Clear reason/comment when un-ticking a row
                return checked ? { ...r, skipChecked: true } : { ...r, skipChecked: false, skipReason: '', comment: '' };
            });
            return { rows };
        });
    }

    handleReasonChange(idx, value) {
        this.setState(prevState => {
            const rows = prevState.rows.map((r, i) => {
                if (i !== idx) return r;
                // Reset comment when switching away from 'Other'
                return { ...r, skipReason: value, comment: value === 'Other' ? r.comment : '' };
            });
            return { rows };
        });
    }

    handleCommentChange(idx, value) {
        this.setState(prevState => {
            const rows = prevState.rows.map((r, i) => (i === idx ? { ...r, comment: value } : r));
            return { rows };
        });
    }

    validate() {
        const { rows } = this.state;
        if (rows.length === 0) {
            return 'Please select at least one skipped chemotherapy cycle.';
        }
        // All chemotherapy cycles must have their Skip flag marked (skipFlag = 1)
        // before the deviation can be registered.
        if (!rows.every(r => r.skipChecked)) {
            return 'Please select and mention reason for all skipped cycles shown here.';
        }
        for (const r of rows) {
            if (!r.skipReason) {
                return 'Please select a Skip Reason for each cycle.';
            }
            if (r.skipReason === 'Other' && !r.comment.trim()) {
                return 'Please add a Comment for cycles marked as "Other".';
            }
        }
        return '';
    }

    registerDeviation() {
        const validationMsg = this.validate();
        if (validationMsg) {
            this.setState({ showValidation: true, validationMsg });
            return;
        }

        const userId = localStorage.getItem('userId');
        const payload = this.state.rows.map(r => ({
            chemoScheduleId: r.chemoScheduleId,
            skipFlag: r.skipChecked ? 1 : 0,
            skipComment: r.skipChecked ? `${r.skipReason} : ${r.comment}` : null,
            updatedByIdUser: { userId },
        }));

        this.setState({ saveLoader: true, showValidation: false, validationMsg: '' });

        fetch(C.getUrl() + '/userCase/updateChemoScheduleSkipStatus', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(res => res.json())
            .then(res => {
                this.setState({ saveLoader: false });
                if (res && res.statusCode === 200) {
                    this.props.registerDeviationSuccess();
                } else {
                    swal({ title: 'Error', text: 'System Error. Unable to proceed.', icon: 'error' });
                }
            })
            .catch(err => {
                console.log('Error : ' + err);
                this.setState({ saveLoader: false });
                swal({ title: 'Error', text: 'System Error. Unable to proceed.', icon: 'error' });
            });
    }

    render() {
        const { showSkippedCyclesPopup, closeModal } = this.props;
        const closePreviewModal = () => {
            this.setState({ showValidation: false, validationMsg: '' });
            closeModal();
        };

        return (
            <Modal id="" show={showSkippedCyclesPopup} centered animation={true} scrollable={true} size="lg">
                <Modal.Header closeButton onClick={() => closePreviewModal()}>
                    <Modal.Title>
                        <h3 className="fs-18 header_title mb-0 text-black">Skipped Chemotherapy Cycles</h3>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container fluid>
                        <Row>
                            <Col lg='12'>
                                <p>Patient chemotherapy records are not found for below cycles and treatment days. Please select appropriate reason by selecting the missed chemotherapy cycles</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12'>
                                {this.state.rows.length ? (
                                    <Table hover responsive="sm" id="skippedCyclesTable">
                                        <thead className='thead-light'>
                                            <tr>
                                                <th className="text-center">Skip</th>
                                                <th className="text-center">Protocol Name</th>
                                                <th className="text-center">Date</th>
                                                <th className="text-center">Cycle Number</th>
                                                <th className="text-center">Treatment Day</th>
                                                <th className="text-center">Skip Reason</th>
                                                <th className="text-center">Comment</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.rows.map((r, idx) => {
                                                const protocolName = r.patTreatmentPlanDTO
                                                    && r.patTreatmentPlanDTO.protocolMstDTO
                                                    && r.patTreatmentPlanDTO.protocolMstDTO.protocolName;
                                                return (
                                                    <tr key={r.chemoScheduleId != null ? r.chemoScheduleId : idx} role="row">
                                                        <td className="text-center">
                                                            <Form.Check
                                                                type="checkbox"
                                                                className="pl-0"
                                                                checked={r.skipChecked}
                                                                onChange={(e) => this.handleCheckChange(idx, e.target.checked)}
                                                            />
                                                        </td>
                                                        <td>{protocolName || ''}</td>
                                                        <td>{this.formatDateDDMonYYYY(r.chemoDt)}</td>
                                                        <td className="text-center">{r.chemoCycleNumber}</td>
                                                        <td className="text-center">{r.treatmentDayNumber}</td>
                                                        <td>
                                                            <Form.Control
                                                                as="select"
                                                                value={r.skipReason}
                                                                disabled={!r.skipChecked}
                                                                onChange={(e) => this.handleReasonChange(idx, e.target.value)}
                                                            >
                                                                <option value="">- Select -</option>
                                                                {SKIP_REASONS.map((reason) => (
                                                                    <option key={reason} value={reason}>{reason}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                value={r.comment}
                                                                disabled={r.skipReason !== 'Other'}
                                                                onChange={(e) => this.handleCommentChange(idx, e.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <div><h3>No skipped cycles found.</h3></div>
                                )}
                            </Col>
                        </Row>
                        {this.state.showValidation && this.state.validationMsg && (
                            <Row className="mt-3">
                                <Col lg='12' className="text-center">
                                    <Alert variant="warning">{this.state.validationMsg}</Alert>
                                </Col>
                            </Row>
                        )}
                    </Container>
                </Modal.Body>
                <Modal.Footer className='text-center'>
                    <Button className="btn btn-secondary" onClick={this.registerDeviation} disabled={this.state.saveLoader}>
                        {this.state.saveLoader && (
                            <Spinner className='mr-2' animation='border' size='1.5rem' />
                        )}
                        Register Deviation
                    </Button>
                    <Button variant="outline-danger" onClick={() => closePreviewModal()}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
